import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { FilterBar } from 'components/molecules/filter-bar';
import { HiddenInfo, StyledDivider } from './common';

const DataCardWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  background-color: var(--white-100);
  box-shadow: var(--shadow-02);
  width: 50%;

  &:hover {
    ${HiddenInfo} {
      visibility: visible;
    }
  }
`;

const DataCardCell = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const StyledFilterBar = styled(FilterBar)`
  display: flex;
  justify-content: space-between;
  box-shadow: none;
  padding: var(--spacing-04) var(--spacing-05);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: var(--spacing-07);
  padding: 0 var(--spacing-05);
  min-height: 300px;
`;

const ExtraInfoSection = styled.div`
  display: flex;
  width: 25%;
  padding: 0 var(--spacing-05);
`;

interface Props {
  content: ReactNode;
  primary?: ReactNode;
  central?: ReactNode;
  secondary?: ReactNode;
  extraInfo?: ReactNode;
}

export const FinancialsDataCard: FC<Props> = ({
  content,
  primary,
  central,
  secondary,
  extraInfo,
}) => {
  return (
    <DataCardWrapper>
      <DataCardCell>
        <StyledFilterBar>
          {primary != null && <FilterBar.Primary>{primary}</FilterBar.Primary>}
          {central != null && <FilterBar.Central>{central}</FilterBar.Central>}
          {secondary != null && (
            <FilterBar.Secondary>{secondary}</FilterBar.Secondary>
          )}
        </StyledFilterBar>
        <Content>{content}</Content>
      </DataCardCell>
      {extraInfo != null && (
        <>
          <StyledDivider
            type="vertical"
            style={{ height: 'calc(100% - (2 * var(--spacing-05)));' }}
          />
          <ExtraInfoSection>{extraInfo}</ExtraInfoSection>
        </>
      )}
    </DataCardWrapper>
  );
};
